// Dependencies
import { Component } from 'react';
import { connect } from 'react-redux';

import CheckBox from 'components/atoms/CheckBox';
import SearchGroup from 'components/atoms/SearchGroup';
import { SetSearchObjectAction } from 'store/actions/layoutActions';
import { RootState, TagType } from 'types';
import { DefaultData, FilterObjectType } from 'types/search';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';

import AdminShortcut from './AdminShortcut';

interface AdminFiltersComponentProps {
    tags: TagType[];
    defaultData: DefaultData;
    filterObject: FilterObjectType;
    setFilterObject: SetSearchObjectAction;
}

interface AdminFiltersComponentState {
    language: string;
    errors: object;
    tags: TagType[];
    filterObject: FilterObjectType;
}

class AdminFilters extends Component<AdminFiltersComponentProps, AdminFiltersComponentState> {
    constructor(props: AdminFiltersComponentProps) {
        super(props);
        this.state = {
            filterObject: props.filterObject,
            errors: {},
            language: 'en',
            tags: [],
        };
    }

    static getDerivedStateFromProps(props: AdminFiltersComponentProps, state: AdminFiltersComponentState) {
        if (checkDifferent(props.tags, state.tags) || checkDifferent(props.filterObject, state.filterObject)) {
            return { tags: props.tags, filterObject: props.filterObject };
        }
        return null;
    }

    handleChange = (value: number) => {
        const { filterObject } = this.state;
        const tags = [...filterObject.tags];

        const updatedTags = tags.includes(value)
            ? tags.filter((tag) => tag !== value) // Remove the value
            : [...tags, value]; // Add the value

        const updatedFilterObject = { ...filterObject, tags: updatedTags };

        this.props.setFilterObject(updatedFilterObject);
    };

    render() {
        return (
            <SearchGroup open title={translate('Admin')}>
                <div className="flex flex-col gap-2">
                    <div className="flex flex-col gap-x-1 bottom-1 border-b border-gray-300 ">
                        {this.state.tags
                            ?.filter((tag: TagType) => {
                                return tag.type === 'system' && tag.status == 'active';
                            })
                            .sort(function (a, b) {
                                if (a.order > b.order) return 1;
                                if (a.order < b.order) return -1;
                                return 0;
                            })
                            .map((tag: TagType) => {
                                return (
                                    <div key={tag.id} className="flex gap-1">
                                        <div>
                                            <CheckBox
                                                name={tag.tag}
                                                onChange={() => {
                                                    this.handleChange(tag.id);
                                                }}
                                                value={this.state.filterObject?.tags.includes(tag.id)}
                                            ></CheckBox>
                                        </div>
                                        <div className="capitalize truncate">{tag.label}</div>
                                    </div>
                                );
                            })}
                    </div>
                    <div className="flex flex-col gap-x-1">
                        {this.state.tags
                            ?.filter((tag: TagType) => {
                                return tag.type === 'admin' && tag.status == 'active';
                            })
                            .sort(function (a, b) {
                                if (a.order > b.order) return 1;
                                if (a.order < b.order) return -1;
                                return 0;
                            })
                            .map((tag: TagType) => {
                                return (
                                    <div key={tag.id} className="flex gap-1">
                                        <div>
                                            <CheckBox
                                                name={tag.tag}
                                                onChange={() => {
                                                    this.handleChange(tag.id);
                                                }}
                                                value={this.state.filterObject?.tags.includes(tag.id)}
                                            ></CheckBox>
                                        </div>
                                        <div className="capitalize truncate">{tag.label}</div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
                <AdminShortcut filterObject={this.props.filterObject} handleChange={this.handleChange}></AdminShortcut>
            </SearchGroup>
        );
    }
}

const AdminFiltersStateToProps = (state: RootState) => ({
    tags: state.port.tags,
    defaultData: state.port.defaultData,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AdminFiltersDispatchToProps = () => ({});

export default connect(AdminFiltersStateToProps, AdminFiltersDispatchToProps)(AdminFilters);
